// eslint-disable-next-line import/no-unresolved
import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import '@/styles/tailwind.css';
import { memo, useEffect, useRef, useState } from 'react';
import { APP_PATH, ENABLE_GOOGLE_CONVERSION } from '@/config';
import { requestForToken, onMessageListener } from './firebase';
import { showNotification } from '@/utils/notificationUtils';
import { isSupported } from 'firebase/messaging';
import { useSaveFCMToken } from '@/features/auth/api/saveFCMToken';
import storage from './utils/storage';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useLocation } from 'react-router-dom';

const InjectScript = memo((props: any) => {
  const divRef: any = useRef(null);

  useEffect(() => {
    if (divRef.current === null) {
      return;
    }
    // create a contextual fragment that will execute the script
    // beware of security concerns!!
    const doc = document.createRange().createContextualFragment(props.script);

    const currentRef: any = divRef.current;
    // clear the div HTML, and append the doc fragment with the script
    currentRef.innerHTML = '';
    const head: any = document.querySelector('head');
    head.appendChild(doc);
    //currentRef.appendChild(doc);
  });

  return <div ref={divRef} />;
});

InjectScript.displayName = 'injectscript';
function App() {
  const [reg, setRegistration] = useState<any>();
  const [notification, setNotification] = useState({ title: '', body: '' });
  const useSaveFCMTokenMutation = useSaveFCMToken();
  // const { user } = useAuth();

  const isFacebookiOSApp = () => {
    const userAgent = navigator.userAgent;
    const isFacebookBrowser = /FBAN|FBAV/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    return isFacebookBrowser && isIOS;
  };

  useEffect(() => {
    (async () => {
      const token = storage.getToken();
      try {
        if (isFacebookiOSApp()) {
          console.log('Running in Facebook Browser.');
          return;
        }

        const hasFirebaseMessagingSupport = await isSupported();
        if (
          token &&
          hasFirebaseMessagingSupport &&
          'serviceWorker' in navigator &&
          navigator.userAgent.indexOf('petskedapp') < 0 &&
          navigator.userAgent.indexOf('Your App Info/Version') < 0
        ) {
          navigator.serviceWorker
            .register(`${APP_PATH}firebase-pet.js`)
            .then(async (r) => {
              if (Notification && Notification.permission !== 'granted') {
                Notification.requestPermission()
                  .then(async function (permission) {
                    if (permission == 'granted') {
                      const token = await requestForToken(r, storage);
                      let obj = {};
                      if (
                        token &&
                        storage &&
                        storage.getFCMToken('fcmToken') &&
                        storage.getFCMToken('oldFcmToken') &&
                        storage.getFCMToken('fcmToken') != storage.getFCMToken('oldFcmToken')
                      ) {
                        obj = {
                          fcmToken: storage.getFCMToken('fcmToken'),
                          oldFcmToken: storage.getFCMToken('oldFcmToken'),
                        };
                        await useSaveFCMTokenMutation.mutateAsync(obj);
                      } else if (
                        storage &&
                        storage.getFCMToken('fcmToken') &&
                        !storage.getFCMToken('oldFcmToken')
                      ) {
                        obj = { fcmToken: storage.getFCMToken('fcmToken') };
                        await useSaveFCMTokenMutation.mutateAsync(obj);
                      }
                    } else if (permission == 'denied') {
                      //alert('To get notifications we need notification permission ');
                    }
                  })
                  .catch((err) => console.log('Error initialising firebase: ', err));
              } else {
                const token = await requestForToken(r, storage);
                let obj = {};
                if (
                  token &&
                  storage &&
                  storage.getFCMToken('fcmToken') &&
                  storage.getFCMToken('oldFcmToken') &&
                  storage.getFCMToken('fcmToken') != storage.getFCMToken('oldFcmToken')
                ) {
                  obj = {
                    fcmToken: storage.getFCMToken('fcmToken'),
                    oldFcmToken: storage.getFCMToken('oldFcmToken'),
                  };
                  await useSaveFCMTokenMutation.mutateAsync(obj);
                } else if (
                  storage &&
                  storage.getFCMToken('fcmToken') &&
                  !storage.getFCMToken('oldFcmToken')
                ) {
                  obj = { fcmToken: storage.getFCMToken('fcmToken') };
                  await useSaveFCMTokenMutation.mutateAsync(obj);
                }
              }
            })
            .catch((err) => {
              console.log('Error initialising firebase: ', err);
            });
        }
      } catch (err) {
        console.log('Error initialising firebase: ', err);
      }
    })();
  }, []);

  // useEffect(() => {
  //   console.log("sadaddasdd")
  //   if (businessQuery?.data?.country) {
  //     changeLanguage(businessQuery.data.country);
  //   }
  // }, [businessQuery?.data?.country]);

  useEffect(() => {
    if (notification?.title) {
      showNotification({
        type: 'success',
        title: notification?.title,
      });
    }
  }, [notification]);
  // onMessageListener()
  //   .then((payload) => {
  //     setNotification({ title: payload?.notification?.title, body: payload?.notification?.body });
  //   })
  //   .catch((err) => console.log('failed: ', err));
  const scriptToInject = `<script async src="https://www.googletagmanager.com/gtag/js?id=G-E84SKHP8MM"></script><script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-E84SKHP8MM');
  gtag('config', 'GTM-K5NR8SWD');
  gtag('config', 'AW-16550157434');
  </script>
   <script id="meta-pixels">
            !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
               fbq('init', '1233619067864683');
              fbq('track', 'PageView');
          </script>
  `;
  return (
    <>
      {ENABLE_GOOGLE_CONVERSION === 'yes' && <InjectScript script={scriptToInject} />}
      {ENABLE_GOOGLE_CONVERSION === 'yes' && <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src="https://www.facebook.com/tr?id=1233619067864683&ev=PageView&noscript=1"
        />
      </noscript>}
      <AppProvider>
        <AppRoutes />
      </AppProvider>
    </>
  );
}

export default App;
